import { render, staticRenderFns } from "./buttom.vue?vue&type=template&id=61da0a8c"
import script from "./buttom.vue?vue&type=script&lang=js"
export * from "./buttom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports